export enum BlockOrdering {
    Alternate = 0,
    Row,
    Column
}